/* eslint-disable i18next/no-literal-string -- css not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const tag = defineSlotRecipe({
  slots: ['root', 'label', 'closeTrigger', 'startElement', 'endElement'],
  className: 'chakra-tag',
  base: {
    root: {
      borderRadius: 'full',
      fontWeight: 'medium',
    },

    closeTrigger: {
      opacity: 0.5,
      cursor: 'pointer',
      _hover: {
        opacity: 1,
      },
    },
    endElement: {
      flexShrink: 0,
      boxSize: 'var(--tag-element-size)',
      me: 'var(--tag-element-offset)',
      _icon: { boxSize: '100%' },
      '&:has(button)': {
        ms: 'calc(var(--tag-element-offset) * -1)',
      },
    },
  },

  variants: {
    size: {
      md: {
        root: {
          px: 4,
        },
      },
      lg: {
        root: {
          px: 4,
        },
        label: {
          lineHeight: 1.2,
        },
      },
    },

    variant: {
      subtle: {
        root: { background: 'colorPalette.50', color: 'chakra-body-text' },
      },

      outline: {
        root: { fontWeight: 'medium', shadowColor: 'colorPalette.solid' },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
    variant: 'subtle',
  },
});
